/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundPaymentRequest
 */
export interface RefundPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    transactionId: string;
    /**
     * 
     * @type {number}
     * @memberof RefundPaymentRequest
     */
    refundAmount: number;
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the RefundPaymentRequest interface.
 */
export function instanceOfRefundPaymentRequest(value: object): value is RefundPaymentRequest {
    if (!('transactionId' in value) || value['transactionId'] === undefined) return false;
    if (!('refundAmount' in value) || value['refundAmount'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function RefundPaymentRequestFromJSON(json: any): RefundPaymentRequest {
    return RefundPaymentRequestFromJSONTyped(json, false);
}

export function RefundPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundPaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionId': json['transactionId'],
        'refundAmount': json['refundAmount'],
        'note': json['note'],
    };
}

export function RefundPaymentRequestToJSON(json: any): RefundPaymentRequest {
    return RefundPaymentRequestToJSONTyped(json, false);
}

export function RefundPaymentRequestToJSONTyped(value?: RefundPaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionId': value['transactionId'],
        'refundAmount': value['refundAmount'],
        'note': value['note'],
    };
}

